import { render } from "./R_ContratoActivoRegistro.vue?vue&type=template&id=d222f572"
import script from "./R_ContratoActivoRegistro.vue?vue&type=script&lang=js"
export * from "./R_ContratoActivoRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__